<template>
  <div class="panel-box">
    <div class="panel-head text-center padding-a-xs">
      {{ title }}
      <span v-show="!!details.upDownstairs && !rsvp.isAsap">({{ details.upDownstairs }})</span>
    </div>
    <div class="panel-body padding-a-m">
      <ul class="unstyled margin-a-z">
        <li v-for="(value, index) in details" class="padding-l-m margin-b-s" v-if="isExtraStop" :key="index">
          <span class="panel-icon">
            <icon :name="panelIcon('location')" class="margin-r-xs"></icon>
          </span>
          <span class="panel-text">{{ value.location }}</span>
        </li>
        <li v-for="(value, index) in details" class="padding-l-m margin-b-s" v-if="index !== 'upDownstairs' && !isExtraStop" :key="`${index}p`">
          <span class="panel-icon">
            <icon :name="panelIcon(index)" class="margin-r-xs"></icon>
          </span>
          <span class="panel-text">{{ value }}</span>
        </li>
        <li v-if="isDropoff">
          <small><i>{{ $t('global.dropoffEstimate') }}</i></small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'panel-location-details',
  props: ['title', 'details', 'isDropoff', 'isExtraStop', 'currentLeg'],
  data () {
    return {
      icon: ''
    }
  },
  computed: {
    rsvp () { return this.$store.state.reservation[this.currentLeg] }
  },
  methods: {
    panelIcon: function (val) {
      switch (val) {
        case 'location': return 'map-marker'
        case 'date': return 'clock-o'
        case 'flight': return 'plane'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/PanelLocationDetails.scss";
</style>



// WEBPACK FOOTER //
// PanelLocationDetails.vue?787d5f48